<template>
  <div class="sync">
    <el-dialog :close-on-click-modal="false" title="产品搬家" width="450px" :visible.sync="visible" :before-close="handleClose">
      <el-row style="font-size:14px;" :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <div class="line_style">已选择 {{ total }} 个产品</div>
            <div class="line_style">
              <div class="grid-content bg-purple">
                <span style="margin: 0 20px 0 0;">保留原产品sku</span>
                <el-radio v-model="form.holdOn" label="01">是</el-radio>
                <el-radio v-model="form.holdOn" label="02">否</el-radio>
              </div>
            </div>
            <div class="line_style">
              <span style="margin: 0 86px 0 0;">店铺</span>
              <el-select style="width:200px" placeholder="请选择目的店铺" clearable filterable size="small" v-model="form.toShopId">
                <el-option v-for="value in shopList" :key="value.shopId" :label="value.shopName" :value="value.shopId">
                </el-option>
              </el-select>
            </div>
            <div class="line_style">
              <span style="margin: 0 58px 0 0;">复制方式</span>
              <el-radio v-model="form.copyType" label="online">上线</el-radio>
              <el-radio v-model="form.copyType" label="draff">草稿</el-radio>
            </div>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">返回</el-button>
        <el-button type="primary" @click="sureImport" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getShopList } from "@/api/system/shopManage"
import { moveProductById } from "@/api/customProduct/product"


export default {
  name: "MoveProduct",
  data() {
    return {
      shopList: [],
      form: {
        platNo:"",
        pIds: "",
        toShopId: "",
        holdOn: "01",
        copyType: "draff",
      },
      total: 0,//选中数据长度
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    platNo: {
      type: String,
      default() {
        return ""
      },
    },
    slectProList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        let pIds = this.slectProList.map((item)=> {
          return item.pId
        })
        this.form = {
          platNo:this.platNo,
          pIds: pIds.join(","),
          holdOn: "01",
          toShopId: "",
          copyType: "draff",
        }
        this.shopList = []
        this.total = this.slectProList.length
        this.getData()
      }
    },
  },
  computed: { },
  mounted() { },
  destroyed() { },
  methods: {
    getData() {
      getShopList({ platNo: this.platNo, authStatus: "02" }).then((res) => {
        this.shopList = res.rows
      })
    },
    handleClose() {
      this.$emit("onClose")
    },
    async sureImport() {
      let form = this._.clone(this.form)
      if (form.toShopId == "") {
        this.msgError("请选择目的店铺")
        return
      }
      this.events.$emit("showSyncHint", true)
      moveProductById(form)
        .then((res) => {
          this.msgSuccess("产品搬家处理成功")
          this.events.$emit("showSyncHint", false)
          this.$emit("onClose")
        })
        .catch((error) => {
          this.msgError("产品搬家处理失败")
          this.events.$emit("showSyncHint", false)
          this.$emit("onClose")
        })
    },
  },
}
</script>

<style scoped>
.sync /deep/.el-table::before {
  display: none;
}

.sync-table {
  overflow-y: auto;
  max-height: 260px;
}

.status {
  margin: 10px 0;
}

.red {
  color: red;
}

.detail-wrap {
  max-height: 180px;
  overflow-y: auto;
}

.line_style {
  line-height: 50px;
}
</style>
